import { useState } from 'react';

export const useStepNavigation = <TStep>(steps: TStep[], initialStep: TStep) => {
  const [step, setStep] = useState(initialStep);

  const decrementStep = () => {
    const index = steps.indexOf(step) - 1;
    setStep(steps.at(index) as TStep);
  };

  const incrementStep = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const index = steps.indexOf(step) + 1;
    setStep(steps.at(index) as TStep);
  };

  return { step, setStep, incrementStep, decrementStep };
};
